
import { Script } from 'gatsby';
import { disableComponentInDev } from '../../utils/hoc/disableComponentInDev'

const options = {
  "enabled": true,
  "chatButtonSetting": {
    "backgroundColor": "#2b3e51",
    "ctaText": "¿Tiene algúna pregunta?",
    "borderRadius": "25",
    "marginLeft": "0",
    "marginBottom": "50",
    "marginRight": "50",
    "position": "right"
  },
  "brandSetting": {
    "brandName": "Watch Project 21",
    "brandSubTitle": "Atención al cliente",
    "brandImg": "https://scontent-mad1-1.xx.fbcdn.net/v/t39.30808-6/222925939_4238950829528964_3518898441824795859_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=00yYxR-K_FoAX_KPFNd&_nc_ht=scontent-mad1-1.xx&oh=00_AfDR74NVK5U3t_WJqfOhWr9gl-K1fksWSOABPR1EaG5BQw&oe=637BFDAA",
    "welcomeText": "Hola.\nEstaremos encantados de ayudarle personalmente.",
    "messageText": "Hola.%0AEstaremos encantados de ayudarle personalmente.",
    "backgroundColor": "#2b3e51",
    "ctaText": "Envíe su pregunta",
    "borderRadius": "25",
    "autoShow": false,
    "phoneNumber": "34934672437"
  }
};

const Scripts = disableComponentInDev(() => (<>
  {/* <Script
    key="trustpilot-widget"
    strategy='idle'
    src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
    type="text/javascript"
  /> */}
  <Script
    key="wati-integration"
    strategy='idle'
    src='https://wati-integration-service.clare.ai/ShopifyWidget/shopifyWidget.js?95728'
    type='text/javascript'
    async
    onLoad={() => {
      if (document.querySelector("#whatsapp-chat-widget")) {
        return;
      }
      // @ts-ignore since this is a third party script
      CreateWhatsappChatWidget(options);
      document.querySelectorAll<HTMLImageElement>(".wa-chat-box-brand").forEach((el: HTMLImageElement) => {
        el.loading = "lazy";
      });
    }} />
</>));

export default Scripts;
